import createPersistedState from 'vuex-persistedstate';

// Store paths defined here will be saved in local storage, persisted data will be visible only on client side-side.

export default ({ store }) => {
    createPersistedState({
        paths: ['dev'],
    })(store);
};
